import { useIntl } from 'react-intl';

import { EM_DASH } from '~/common/constants/unicode';
import { Box } from '~/eds/src/components/Box/Box';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';

import { getSingleFieldValue } from '../../helpers';
import { BaseFieldProps } from './fieldTypes';

export const TextAreaField = ({
  field,
  editMode,
  editData,
  onEditDataChange,
  isWssField,
}: BaseFieldProps) => {
  const intl = useIntl();
  const presentValue = editData[field.id];

  if (editMode) {
    const stringValue =
      typeof presentValue === 'string' || typeof presentValue === 'number'
        ? String(presentValue)
        : '';

    return (
      <Box flex="1">
        <TextArea
          name={field.name}
          aria-label={field.name}
          value={stringValue}
          onChange={(updatedValue: string | null) =>
            onEditDataChange(field.id, updatedValue)
          }
          disabled={!field.is_editable || isWssField(field)}
          rows={5}
          placeholder={intl.formatMessage(
            {
              id: 'TextAreaField.enterFieldName',
              defaultMessage: 'Enter {fieldName}',
              description:
                'Placeholder text for textarea field. Example: fieldName = "Description"',
            },
            { fieldName: field.name },
          )}
          width="100%"
        />
      </Box>
    );
  }

  const singleValue = getSingleFieldValue(field.value);
  return singleValue ? singleValue.display_value : EM_DASH;
};
